import { borwserHistory } from '@zenlayer/portal-utils';
import { default as qs, default as queryString } from 'query-string';
import { parseUrlSearch } from '../../common/utils';
const DEFAULT_queryKey = 'detail_query';
function isEmptyObject(obj) {
    return Object.keys(obj).length === 0;
}
export function detailUrlParamsStringify(params, otherSearch = {}, queryKey = DEFAULT_queryKey) {
    return qs.stringify({
        ...otherSearch,
        [queryKey]: isEmptyObject(params)
            ? undefined
            : qs.stringify(params, { arrayFormat: 'bracket' }),
    });
}
export const detailUrlParamsParse = (search, queryKey = DEFAULT_queryKey) => {
    const searchObj = parseUrlSearch(search);
    return qs.parse(searchObj?.[queryKey], {
        arrayFormat: 'bracket',
    });
};
export function mergeUrlParamWithLocation(opts) {
    const { origin, pathname, search, hash } = new URL(location.href);
    const urlOrigin = (opts.origin ?? origin)?.replace?.(/\/$/, '');
    const urlPathname = `/${opts.pathname ?? pathname}`.replace(/^\/+/i, '/');
    const urlSearch = (opts.search ?? search)?.replace?.(/^\?+/, '');
    const urlHash = (opts.hash ?? hash)?.replace?.(/^\#/, '');
    const targetUrl = new URL(`${urlOrigin}${urlPathname}${urlSearch ? `?${urlSearch}` : ''}${urlHash ? `#${urlHash}` : ''}`);
    return targetUrl;
}
/***
 *
 * https://bugzilla.mozilla.org/show_bug.cgi?id=1813755
 *
 *
 */
export function changeUrlByHistory(opts, type) {
    const url = mergeUrlParamWithLocation({
        pathname: opts.pathname,
        search: opts?.search,
    }).toString();
    if (type == 'replace') {
        borwserHistory.replace(url, {});
    }
    else {
        borwserHistory.push(url, {});
    }
}
export function generateURLQueryFromOptions(opts, defaultFullScreen = false) {
    const urlObj = normalizeUrlPath(opts.path);
    const otherQuery = {
        ...urlObj.query,
        full_screen: opts.fullScreen ?? defaultFullScreen,
        addition_route: true,
        addition_name: opts.name,
        addition_i18nKey: opts.i18nKey,
    };
    return otherQuery;
}
export function normalizeUrlPath(path) {
    return queryString.parseUrl(path);
}
export function uniqueByKey(arr, key) {
    const seen = new Map();
    return arr.filter((item) => {
        if (!item[key]) {
            return true;
        }
        if (!seen.has(item[key])) {
            seen.set(item[key], true);
            return true;
        }
        return false;
    });
}
